import { z } from 'zod';
import type { IconName } from '@/components/Icon/iconMap';
import { type EquipmentStatus, EquipmentStatus as ES, type EquipmentStatusFilter } from './-query/type';
import { buildPlaceFilterClearOnTabChange } from './utils/placeFilterVisibility';
const equipmentStatusValues = Object.values(ES) as [EquipmentStatus, ...EquipmentStatus[]];
export const EquipmentStatusSchema = z.enum(['ALL', ...equipmentStatusValues]);
export const STATUS_TABS = [ES.AVAILABLE, ES.ASSIGNED, ES.PLACED, ES.UNDER_REPAIR, 'ALL', ES.DECOMMISSIONED] as const satisfies readonly EquipmentStatusFilter[];
export function buildEquipmentTabChangeSearch(tab: string) {
  const result = EquipmentStatusSchema.safeParse(tab);
  const status: EquipmentStatusFilter = result.success ? result.data : 'ALL' as const;
  return {
    status,
    pageIndex: 0,
    sortColumn: undefined,
    sortOrder: undefined,
    ...buildPlaceFilterClearOnTabChange(status)
  };
}
export const TAB_TO_ICON: Record<EquipmentStatusFilter, IconName | null> = {
  ALL: null,
  [ES.AVAILABLE]: 'Inventory',
  [ES.ASSIGNED]: 'UserRoundCheckIcon',
  [ES.PLACED]: 'OriginalPlacementCheckIcon',
  [ES.UNDER_REPAIR]: 'ConstructionIcon',
  [ES.DECOMMISSIONED]: 'Trash2Icon'
};